import { useQuery } from '@apollo/client';

import HandleQuery from '@components/HandleQuery';
import MessagesLoader from '@components/loaders/MessagesLoader';
import Messages from '@components/messaging/Messages';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useSubscribeToJourney from '@hooks/subscriptions/useSubscribeToJourney';
import {
  GetJourneyForMessagesDocument,
  GetJourneyForMessagesQuery,
  GetJourneyForMessagesQueryVariables
} from '@typing/Generated';

type Props = {
  journeyId: string;
};

const ExpertJourneyMessagesPage = ({ journeyId }: Props) => {
  const getJourneyForMessagesQuery = useQuery<GetJourneyForMessagesQuery, GetJourneyForMessagesQueryVariables>(
    GetJourneyForMessagesDocument,
    {
      variables: {
        id: journeyId
      }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getJourneyForMessagesQuery.refetch();
  });

  return (
    <ExpertJourneyPage
      gradient={false}
      helmetKey="pageTitles.expertJourney.messages.show"
      journeyId={journeyId}
      mobileSmallPadding
    >
      <HandleQuery loadingContent={<MessagesLoader />} query={getJourneyForMessagesQuery}>
        {data => <Messages journey={data.journey} />}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyMessagesPage;
